import { sendRequest } from "../libs/axiosConfig";

export const getMetricCatalogApi = async () => {
  const res = await sendRequest({
    url: "/api/v1/admin/metric-catalog",
    method: "GET",
  });
  return res;
};


// export const getMetricLevelInsightsApi = async () => {
//   const res = await sendRequest({
//     url: "/api/v1/recommendations?companyId={COMPANY_ID}&year={YYYY}",
//     method: "GET",
//   });
//   return res;
// };

export const getMetricLevelInsightsApi = async ({ companyId, year }) => {
  console.debug("[API] getMetricLevelInsightsApi params:", { companyId, year });
  const res = await sendRequest({
    url: `/api/v1/recommendations?companyId=${companyId}&year=${year}`,
    method: "GET",
  });
  return res;
};
export const getExpertImpactsApi = async (expertId) => {
  const res = await sendRequest({
    url: `/api/v1/experts/${expertId}/impacts`,
    method: "GET",
  });
  return res;
};
export const createExpertImpactApi = async (expertId, payload) => {
  return await sendRequest({
    url: `/api/v1/experts/${expertId}/impacts`,
    method: "POST",
    data: payload, 
  });
};